import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { Observable, Observer } from 'rxjs';
import { environment } from '../environments/environment';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

declare let bootbox: any;

export interface sendAPIRequestOptions {
	headers?: { [key:string]: any }[], // add headers to the request, default X-Authorization and X-Locale
	suppressToken?: boolean,
	suppressTokenCheck?: boolean,
	suppressPathResolve?: boolean,
	overrideDefaultErrorHandler?: (error, observer: Observer<any>) => void, // override default error handle
	beforeDefaultErrorHandler?: (error) => void, // excute before default error handle
}

@Injectable()
export class ApiService {
	public constructor(
		private http: Http,
		private router: Router,
	) {}

	// only show 1 bootbox at a time
	private _showingPrompt: boolean = false;

	// only refresh token once per time
	private _refreshingToken: boolean = false;

	// send api request
	public sendApiRequest(method: string, endpoint: string, data: any = {}, options: sendAPIRequestOptions = {}): Observable<any> {
		let jwt = localStorage.getItem('jwt');
		let headers = {};

		if(!options.suppressToken && jwt) {
			if(!options.suppressTokenCheck && !this._refreshingToken) {
				this._refreshingToken = true;
				this._checkJwt(jwt)
				.then(_jwt => {
					// ensure not to refresh too quickly
					setTimeout(() => {
						this._refreshingToken = false;
					}, 60e3);
				});
			}
			
			headers['Authorization'] = `BEARER ${jwt}`;
		}

		// set locale header
		let langMap = { en: 'en', zh_hk: 'zh-HK', zh_cn: 'zh-CN' };

		// add custom headers
		if(options.headers) {
			headers = Object.assign(headers, options.headers);
		}

		let requestHeaders = new Headers(headers);
		let requestOptions = new RequestOptions({
			headers: requestHeaders
		});

		let path;
		if(options.suppressPathResolve === true) {
			path = endpoint;
		}
		else {
			path = environment.getApiPath(endpoint);
		}

		let httpObservable = null;
		if(method == 'get') {
			httpObservable = this.http.get(path, requestOptions);
		}
		else if(method == 'post') {
			httpObservable = this.http.post(path, data, requestOptions);
		}
		else if(method == 'put') {
			httpObservable = this.http.put(path, data, requestOptions);
		}
		else if(method == 'delete') {
			httpObservable = this.http.delete(path, requestOptions);
		}
		else {
			throw new Error('Unsupported HTTP method');
		}

		// wrap a handle before returning http observable
    return Observable.create((observer: Observer<any>) => {
      httpObservable
      .toPromise()
      .then(resp => {
        // refresh jwt if X-Authorization-Token
        let token = resp.headers.get('Authorization-Token');
        if(token) {
          localStorage.setItem('jwt', token);
        }

        observer.next(resp);
        observer.complete();
      })
      .catch(err => {
      	if(options.overrideDefaultErrorHandler) {
					return options.overrideDefaultErrorHandler(err, observer);
				}
				else {
					if(options.beforeDefaultErrorHandler) {
						options.beforeDefaultErrorHandler(err);
					}
					return this.defaultRequestErrorHandler(err, observer);	
				}
      });
    });

	}

	// check whether jwt expiry
	private _checkJwt = (jwt) => {
		return new Promise(resolve => {
			let val = jwt.split('.');
			let info = JSON.parse(atob(val[1]));
			let now = new Date();
			let diff = info.exp*1000 - now.getTime();

			// expired
			if(diff < 0) {
				resolve();
			}
			// refresh token
			else if(diff <= environment.refreshJwtTimeFrame*1000*60) {
				console.log('Refresh token');
				this.sendApiRequest('get', 'user/refresh_token', {}, {suppressTokenCheck: true})
				.toPromise()
				.then(res => {
					let json = res.json();
					localStorage.setItem('jwt', json.token);
					resolve(json.token);
				});
			}
			// pass
			else {
				resolve(jwt);
			}
		});
	};

	// special error messages handle for laravel plugin
	private _errorMessage = {
		token_expired: 'Session expried. Please login again.',
		token_not_provided: 'Please login.',
		token_invalid: 'Session error. Please contact HKAF support.',
		user_not_found: 'Incorrect login credentials.'
	};

	// default request error handler
	private defaultRequestErrorHandler(err, observer: Observer<any>) {
		try {
			let json = err.json();
			let errTitle = 'Sorry';
			let errMsg = 'System error. Please contact HKAF support.';

			// use the err msg provided by server
			if(err.status == 400 || err.status == 401 || err.status == 403) {
				if(json.class == 'ValidationException' && Object.keys(json.error).length > 0) {
					let _errMsg = '';
					for(let i in json.error) {
						_errMsg += `<li>${json.error[i]}</li>`;
					}
					errTitle = 'Validation Fail';
					errMsg = `<ul>${_errMsg}</ul>`;
				}
				else {
					errMsg = json.error || json;
				}
			}
			
			// show alert
			if(!this._showingPrompt) {
				this._showingPrompt = true;
				bootbox.alert({
					title: `<span class="red">${errTitle}</span>`,
					message: this._errorMessage[errMsg] || errMsg,
					callback: () => {
						this._showingPrompt = false;
					}
				});
			}

			return observer.error(err);
		}
		catch(e) {
			console.error(err);
			console.error('Error in defaultRequestErrorHandler', e);
			return observer.error(err);
		}
	}
}


// WEBPACK FOOTER //
// ./src/services/api.service.ts